<template>
  <div class="modal__footer">
    <slot v-bind="{ close }" />
  </div>
</template>

<script setup lang="ts">
const $modal = inject('$modal', {
  close: (...args: any) => args
});

const close = (...args: any) => $modal.close(...args);
</script>

<style lang="postcss">
.modal__footer {
  @apply relative z-[1] bg-white py-5 pl-8 pr-5;

  box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.08);
}
</style>
